module.exports = __webpack_public_path__ + "media/images/payment/westernunion-721c7f1ed294f8269d1876bb131d8dba.svg";